import { useNavigate } from 'react-router-dom'
import { useAuth } from '../../context/AuthContext'
import { colors, font } from '../../design/tokens'

// Home / lanzador de la app de BI. Acá se van sumando reportes con el tiempo.
const REPORTES = [
  { id: 'ventas', icono: '📈', titulo: 'Ventas', desc: 'Facturación, productos, vendedores', to: '/panel/ventas', activo: true },
  { id: 'cobranzas', icono: '💰', titulo: 'Cobranzas', desc: 'Recaudación y deuda', activo: false },
  { id: 'clientes', icono: '👥', titulo: 'Clientes', desc: 'Recurrencia y nuevos', activo: false },
  { id: 'stock', icono: '📦', titulo: 'Stock', desc: 'Rotación y quiebres', activo: false },
]

export default function BiAppHome() {
  const navigate = useNavigate()
  const { user } = useAuth()
  const nombre = (user?.nombre || '').split(' ')[0]

  return (
    <div>
      <div style={{ marginBottom: 18 }}>
        <h1 style={{ margin: 0, fontSize: 22, fontFamily: font.sans, color: colors.text }}>
          {nombre ? `Hola, ${nombre}` : 'Inteligencia comercial'}
        </h1>
        <p style={{ margin: '4px 0 0', fontSize: 13, color: colors.textSec, fontFamily: font.sans }}>Elegí un reporte</p>
      </div>

      <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
        {REPORTES.map((r) => (
          <button
            key={r.id}
            onClick={() => r.activo && navigate(r.to)}
            disabled={!r.activo}
            style={{
              display: 'flex', alignItems: 'center', gap: 14, textAlign: 'left',
              padding: '16px 16px', borderRadius: 14, border: `1px solid ${colors.border}`,
              background: colors.bg, cursor: r.activo ? 'pointer' : 'default',
              opacity: r.activo ? 1 : 0.55, width: '100%',
            }}
          >
            <span style={{ fontSize: 26, width: 34, textAlign: 'center', flexShrink: 0 }}>{r.icono}</span>
            <span style={{ flex: 1, minWidth: 0 }}>
              <span style={{ display: 'block', fontFamily: font.sans, fontWeight: 600, fontSize: 16, color: colors.text }}>{r.titulo}</span>
              <span style={{ display: 'block', fontSize: 12.5, color: colors.textSec, fontFamily: font.sans }}>{r.desc}</span>
            </span>
            {r.activo
              ? <span style={{ color: colors.textMeta, fontSize: 20, flexShrink: 0 }}>›</span>
              : <span style={{ fontSize: 10, fontWeight: 700, color: colors.textMeta, textTransform: 'uppercase', letterSpacing: '0.04em', flexShrink: 0 }}>Pronto</span>}
          </button>
        ))}
      </div>
    </div>
  )
}
